import React, { useState, useContext } from "react";

import moment from "moment";

import { DataTable, PageHero, Page } from "src/components/common";
import { Button } from "src/components/buttons";

import fleetErrorAPI from "src/admin/Organization/OrganizationError/FleetErrorAPI";
import {
	ClearFilterButton,
	ActionIcon,
} from "src/components/forms/ActionColumnIconsAndButton";
import useGetDataHook from "src/admin/Organization/Courses/useGetDataHook";
import {
	filterByStatus,
	StatusFilterMethod,
	setStatusCellValue,
} from "src/components/forms/StatusFilter";
import {
	setDateColumnCellValue,
	DateFilter,
	dateFilterMethod,
} from "src/components/forms/DateFilter";
import { IDate } from "src/common/IDate";
import { Tooltip } from "antd";
import PickListContext from "src/context/pickListContext";

interface IProps {
	match?: any;
	history?: any;
}

const FleetErrors = (props: IProps) => {
	const [{ data: fleetErrors, isLoading }] = useGetDataHook<FleetErrorDTO[]>(
		[],
		{
			apiCallFunc: fleetErrorAPI.getFleetErrors,
			params: [{}],
		}
	);
	const [filtered, setFiltered] = useState([]);

	const [lastModifiedDate, setLastModifiedDate] = React.useState<IDate | null>(
		null
	);

	const { filterByPickListItem, setColumnValue } = useContext(PickListContext);

	const filterByNumberValue = () => (filter: any, row: any) => {
		if (filter.value === "") {
			return true;
		}

		return row[filter.id] === Number(filter.value);
	};

	const filterByStringValue = () => (filter: any, row: any) => {
		if (filter.value === "") {
			return true;
		}

		return row[filter.id].startsWith(filter.value);
	};

	const onDateChange = (accessor: string, onChange: any) => (e: any) => {
		setLastModifiedDate({
			start: moment.utc(e[0]).local(),
			end: moment.utc(e[1]).local(),
		});
		onChange(e);
	};

	const clearFilters = () => {
		setLastModifiedDate(null);
		setFiltered([]);
	};

	const columns = [
		{
			accessor: "id",
			show: false,
		},
		{
			Header: <Tooltip title="Skills Category">Skills Category</Tooltip>,
			accessor: "skillCategory",
			Cell: (row: any) => setColumnValue(row.value),
			filterMethod: filterByPickListItem("SkillCategory"),
		},
		{
			Header: <Tooltip title="Error Code">Error Code</Tooltip>,
			accessor: "errorCode",
			filterMethod: filterByStringValue,
		},
		{
			Header: <Tooltip title="Error Category">Error Category</Tooltip>,
			accessor: "errorCategory",
			Cell: (row: any) => setColumnValue(row.value),
			filterMethod: filterByPickListItem("ErrorCategory"),
		},
		{
			Header: <Tooltip title="Max Allowed">Max Allowed</Tooltip>,
			accessor: "maxAllowed",
			filterMethod: filterByNumberValue,
		},
		{
			Header: <Tooltip title="Points">Points</Tooltip>,
			accessor: "points",
			Cell: (row: any) => setColumnValue(row.value),
			filterMethod: filterByPickListItem("PointCategory"),
		},
		{
			Header: <Tooltip title="Description">Description</Tooltip>,
			accessor: "description",
			filterMethod: filterByStringValue,
		},
		{
			Header: <Tooltip title="Active">Active</Tooltip>,
			accessor: "isActive",
			filterMethod: filterByStatus("isActive"),
			Filter: StatusFilterMethod,
			Cell: setStatusCellValue,
		},
		{
			Header: <Tooltip title="Last Modified">Last Modified</Tooltip>,
			accessor: "lastModified",
			Cell: setDateColumnCellValue,
			Filter: ({ onChange }: { onChange: any }) => (
				<DateFilter
					accessor="lastModified"
					date={lastModifiedDate}
					onChange={onChange}
					onDateChange={onDateChange}
				/>
			),
			filterMethod: dateFilterMethod("lastModified"),
		},
		{
			Header: <Tooltip title="Actions">Actions</Tooltip>,
			Cell: <ActionIcon title="details" type="open" />,
			Filter: <ClearFilterButton onClick={clearFilters} />,
		},
	];

	const toDetailsPage = (e: any, name: string, rowInfo: any = undefined) => {
		if (name === "createNew") {
			props.history.push({
				pathname: `/admin/fleet-errors/-1`,
				state: fleetErrors,
			});
		}

		if (name === "editExisting" && rowInfo !== undefined) {
			e.stopPropagation();
			props.history.push({
				pathname: `/admin/fleet-errors/${rowInfo.row.id}`,
				state: fleetErrors,
			});
		}
	};

	const getActionLink = (rowId: any): string => {
		return `/admin/fleet-errors/${rowId}`;
	};

	const onRowClick = ({ row }: any) => {
		props.history.push(getActionLink(row.id));
	};

	if (fleetErrors !== undefined) {
		return (
			<Page title="Fleet errors">
				<PageHero title="Fleet errors" />
				<div className="container-fluid">
					<div className="d-flex mb-4">
						<div className="ml-auto">
							<Button
								onClick={(e: any) => toDetailsPage(e, "createNew")}
								className="btn-primary"
							>
								New Error
							</Button>
						</div>
					</div>
					<DataTable
						data={fleetErrors}
						columns={columns}
						filterable={true}
						filtered={filtered}
						onRowClick={onRowClick}
						onFilteredChange={(e: any) => setFiltered(e)}
						loading={isLoading}
					/>
				</div>
			</Page>
		);
	}
	return null;
};
export default FleetErrors;
